import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';
import CircularProgress from '@mui/material/CircularProgress';

import { ContentWrapper, HeaderWrapper, NavButton } from '@styles/ContactManager/HeaderStyles';
import { LoaderWrapper } from '@styles/StyledDiv';
import { WorkflowDetails } from './components/WorkflowDetails/WorkflowDetails';
import { ContactDetails } from './components/ContactDetails';

import { IContactManagerHeaderProps } from './interfaces';

export const ContactManagerHeader = ({
  contactId,
  leadId,
  assetId,
  dealId,
  contactDetailsData,
  leadData,
  leads,
  dealSummary,
  assets,
  isLoading,
  onArrowClick,
  onOpenCreditReport,
  currentTab,
}: IContactManagerHeaderProps) => (
  <HeaderWrapper>
    {isLoading ? (
      <LoaderWrapper>
        <CircularProgress color="secondary" />
      </LoaderWrapper>
    ) : (
      <>
        <ContentWrapper>
          <NavButton onClick={() => onArrowClick(true)}>
            <ChevronLeftIcon width={20} />
          </NavButton>

          <ContactDetails
            leadId={leadId}
            leads={leads}
            assetId={assetId}
            dealId={dealId}
            data={contactDetailsData}
            leadData={leadData}
            dealSummary={dealSummary}
            assets={assets}
            contactId={contactId}
            onOpenCreditReport={onOpenCreditReport}
          />

          <NavButton onClick={() => onArrowClick(false)}>
            <ChevronRightIcon width={20} />
          </NavButton>
        </ContentWrapper>
      </>
    )}

    <WorkflowDetails
      leadId={leadId}
      dealId={dealId}
      currentTab={currentTab}
    />
  </HeaderWrapper>
);
